module.exports = __webpack_public_path__ + "static/picture-2-08632593026d652979c7390d137a3e3a.png";